{
  "spacing": {
    "auforumassurance": {
      "spacing-20": "4px",
      "spacing-30": "8px",
      "spacing-40": "12px",
      "spacing-50": "16px",
      "spacing-60": "24px",
      "spacing-70": "32px",
      "spacing-80": "48px",
      "spacing-90": "64px",
      "spacing-100": "80px",
      "spacing-10": "2px"
    },
    "dealt": {
      "spacing-20": "4px",
      "spacing-30": "8px",
      "spacing-40": "12px",
      "spacing-50": "16px",
      "spacing-60": "24px",
      "spacing-70": "32px",
      "spacing-80": "48px",
      "spacing-90": "64px",
      "spacing-100": "80px",
      "spacing-10": "2px"
    },
    "dougs": {
      "spacing-20": "4px",
      "spacing-30": "8px",
      "spacing-40": "12px",
      "spacing-50": "16px",
      "spacing-60": "24px",
      "spacing-70": "32px",
      "spacing-80": "48px",
      "spacing-90": "64px",
      "spacing-100": "80px",
      "spacing-10": "2px"
    },
    "indy": {
      "spacing-20": "4px",
      "spacing-30": "8px",
      "spacing-40": "12px",
      "spacing-50": "16px",
      "spacing-60": "24px",
      "spacing-70": "32px",
      "spacing-80": "48px",
      "spacing-90": "64px",
      "spacing-100": "80px",
      "spacing-10": "2px"
    },
    "jump": {
      "spacing-20": "4px",
      "spacing-30": "8px",
      "spacing-40": "12px",
      "spacing-50": "16px",
      "spacing-60": "24px",
      "spacing-70": "32px",
      "spacing-80": "48px",
      "spacing-90": "64px",
      "spacing-100": "80px",
      "spacing-10": "2px"
    },
    "legalplace": {
      "spacing-20": "4px",
      "spacing-30": "8px",
      "spacing-40": "12px",
      "spacing-50": "16px",
      "spacing-60": "24px",
      "spacing-70": "32px",
      "spacing-80": "48px",
      "spacing-90": "64px",
      "spacing-100": "80px",
      "spacing-10": "2px"
    },
    "legalstart": {
      "spacing-20": "4px",
      "spacing-30": "8px",
      "spacing-40": "12px",
      "spacing-50": "16px",
      "spacing-60": "24px",
      "spacing-70": "32px",
      "spacing-80": "48px",
      "spacing-90": "64px",
      "spacing-100": "80px",
      "spacing-10": "2px"
    },
    "light": {
      "spacing-20": "4px",
      "spacing-30": "8px",
      "spacing-40": "12px",
      "spacing-50": "16px",
      "spacing-60": "24px",
      "spacing-70": "32px",
      "spacing-80": "48px",
      "spacing-90": "64px",
      "spacing-100": "80px",
      "spacing-10": "2px"
    },
    "obat": {
      "spacing-20": "4px",
      "spacing-30": "8px",
      "spacing-40": "12px",
      "spacing-50": "16px",
      "spacing-60": "24px",
      "spacing-70": "32px",
      "spacing-80": "48px",
      "spacing-90": "64px",
      "spacing-100": "80px",
      "spacing-10": "2px"
    },
    "phenix": {
      "spacing-20": "4px",
      "spacing-30": "8px",
      "spacing-40": "12px",
      "spacing-50": "16px",
      "spacing-60": "24px",
      "spacing-70": "32px",
      "spacing-80": "48px",
      "spacing-90": "64px",
      "spacing-100": "80px",
      "spacing-10": "2px"
    },
    "previi": {
      "spacing-20": "4px",
      "spacing-30": "8px",
      "spacing-40": "12px",
      "spacing-50": "16px",
      "spacing-60": "24px",
      "spacing-70": "32px",
      "spacing-80": "48px",
      "spacing-90": "64px",
      "spacing-100": "80px",
      "spacing-10": "2px"
    },
    "propulse": {
      "spacing-20": "4px",
      "spacing-30": "8px",
      "spacing-40": "12px",
      "spacing-50": "16px",
      "spacing-60": "24px",
      "spacing-70": "32px",
      "spacing-80": "48px",
      "spacing-90": "64px",
      "spacing-100": "80px",
      "spacing-10": "2px"
    },
    "qonto": {
      "spacing-20": "4px",
      "spacing-30": "8px",
      "spacing-40": "12px",
      "spacing-50": "16px",
      "spacing-60": "24px",
      "spacing-70": "32px",
      "spacing-80": "48px",
      "spacing-90": "64px",
      "spacing-100": "80px",
      "spacing-10": "2px"
    },
    "resco": {
      "spacing-20": "4px",
      "spacing-30": "8px",
      "spacing-40": "12px",
      "spacing-50": "16px",
      "spacing-60": "24px",
      "spacing-70": "32px",
      "spacing-80": "48px",
      "spacing-90": "64px",
      "spacing-100": "80px",
      "spacing-10": "2px"
    },
    "revital": {
      "spacing-20": "4px",
      "spacing-30": "8px",
      "spacing-40": "12px",
      "spacing-50": "16px",
      "spacing-60": "24px",
      "spacing-70": "32px",
      "spacing-80": "48px",
      "spacing-90": "64px",
      "spacing-100": "80px",
      "spacing-10": "2px"
    },
    "shine": {
      "spacing-20": "4px",
      "spacing-30": "8px",
      "spacing-40": "12px",
      "spacing-50": "16px",
      "spacing-60": "24px",
      "spacing-70": "32px",
      "spacing-80": "48px",
      "spacing-90": "64px",
      "spacing-100": "80px",
      "spacing-10": "2px"
    },
    "sidecare": {
      "spacing-20": "4px",
      "spacing-30": "8px",
      "spacing-40": "12px",
      "spacing-50": "16px",
      "spacing-60": "24px",
      "spacing-70": "32px",
      "spacing-80": "48px",
      "spacing-90": "64px",
      "spacing-100": "80px",
      "spacing-10": "2px"
    },
    "superindep": {
      "spacing-20": "4px",
      "spacing-30": "8px",
      "spacing-40": "12px",
      "spacing-50": "16px",
      "spacing-60": "24px",
      "spacing-70": "32px",
      "spacing-80": "48px",
      "spacing-90": "64px",
      "spacing-100": "80px",
      "spacing-10": "2px"
    }
  }
}
